import { VaccineRecordErrorVariant } from 'actions/pets/PetsErrors';
import { Action } from 'redux';
import { Pet } from 'types/Pet';

export const PETS_RESET = 'pets/reset';
export const PETS_ERROR = 'pets/error';
export const PETS_CLEAR_VACCINE_RECORD_ERROR = 'pets/clear_vaccine_record_error';

export const PETS_SAVE_START = 'pets/save_start';
export const PETS_SAVE_SUCCESS = 'pets/save_success';

interface PetsResetAction extends Action<typeof PETS_RESET> {}

interface PetsErrorAction extends Action<typeof PETS_ERROR> {
    payload?: {
        vaccineRecordError?: VaccineRecordErrorVariant;
    };
}

interface PetsClearVaccineRecordErrorAction
    extends Action<typeof PETS_CLEAR_VACCINE_RECORD_ERROR> {}

interface PetsSaveStartAction extends Action<typeof PETS_SAVE_START> {}

interface PetsSaveSuccessAction extends Action<typeof PETS_SAVE_SUCCESS> {
    payload: {
        pet: Pet;
    };
}

export type PetsAction =
    | PetsResetAction
    | PetsErrorAction
    | PetsClearVaccineRecordErrorAction
    | PetsSaveStartAction
    | PetsSaveSuccessAction;
